import { lazily } from "react-lazily";

import { lazyRouteLoader } from "app/utils/lazyRouteLoader";

import type { PreloadingRouteProps } from "app/utils/lazyRouteLoader";

// Routes.tsx imports this module statically, so it is part of the app shell's
// bundle: the page and its preload module may only be imported dynamically
// here, or the split that lets the loader run ahead of the page's chunk is
// lost.

const { PoliciesAndCollectionsRoute } = lazily(
  () => import("./PoliciesAndCollectionsRoot"),
);

/** The /admin/policies index route: see PoliciesAndCollectionsRoot. */
export const policiesRoute: PreloadingRouteProps = {
  element: <PoliciesAndCollectionsRoute />,
  loader: lazyRouteLoader({
    load: () =>
      import("./policiesPreload").then((module) =>
        module.createPoliciesLoader(),
      ),
    warm: () => import("./PoliciesAndCollectionsRoot"),
  }),
  // Every tab loads its own data and the tables refetch in place, so nothing
  // on the policies page needs the loader to run again while it is open.
  shouldRevalidate: () => false,
};
